import { createRouter, createWebHistory } from 'vue-router'
import mapPage from '../components/mapPage_main.vue'
import dashboardPage from '../components/dashboardPage.vue'
import dashboardPageTest from '../components/dashboardPage_test.vue'
import listDevicesPage from '../components/listDevices_page.vue'
import listUsersPage from '../components/listUsers_page.vue'
import test_management_user from '@/components/management/test_management_user.vue'

import User_Createuser from "../components/settings/users/createuser_page.vue";
import User_Listuser from '../components/settings/users/listuser_pages.vue'
import Device_Createdevice from "../components/settings/devices/createdevice_page.vue"
import Device_Listdevice from "../components/settings/devices/listdevice_page.vue"
import Device_template from "../components/settings/devices/create_template_data.vue"
import Device_Listtemplate from "../components/settings/devices/list_template_data.vue"
import group_Listplan from "../components/settings/group/listgroup_page.vue"
import GroupPlan from "../components/settings/group/group_plan_page.vue"
import GroupUser from "../components/settings/group/group_user_page.vue"
import Group_Createpage from "@/components/settings/group/creategroup_page.vue";
import plan_Listplan from "../components/settings/plan/listplan_page.vue"
import Plan_Createpage from "../components/settings/plan/createplan_page.vue"
import Info from "../components/settings/infopage/user_info.vue"

import login_page from '@/components/login_page.vue'

import { autoLoginForSubdomain } from '@/utils/subdomainAutoLogin'


import axios from 'axios'
const routes = [
  {
  path: "/login",
  name: "login",
  component: login_page,
},

  {
  path: "/management/info",
  name: "infoUser",
  component: Info,
},
{
  path: "/info",
  name: "info",
  component: Info,
},
  {
    path: "/management/user/createuser",
    name: "createuser",
    component: User_Createuser,
    meta: { requiresAuth: true }
  },
  {
    path: "/management/user/listuser",
    name: "listuser",
    component: User_Listuser,
    meta: { requiresAuth: true }
  },
  {
    path: "/management/device/create",
    name: "createdevice",
    component: Device_Createdevice,
    meta: { requiresAuth: true }
  },
  {
    path: "/management/device/templatecreate",
    name: "createdevice_template",
    component: Device_template,
    meta: { requiresAuth: true }
  },
  {
    path: "/management/device/listtemplate",
    name: "device_listtemplate",
    component: Device_Listtemplate,
    meta: { requiresAuth: true }
  },
  
  {
    path: "/management/device/list",
    name: "listdevice",
    component: Device_Listdevice,
    meta: { requiresAuth: true }
  },
  {
    path: "/management/plan/list",
    name: "listplan",
    component: plan_Listplan,
    meta: { requiresAuth: true }
  },
  {
    path: "/management/plan/create",
    name: "createplan",
    component: Plan_Createpage,
    meta: { requiresAuth: true }
  },
  {
    path: "/management/group/home",
    name: "home",
    component: group_Listplan,
    meta: { requiresAuth: true }
  },
  {
    path: "/management/group/list",
    name: "listgroup",
    component: group_Listplan,
    meta: { requiresAuth: true }
  },
  {
    path: "/management/group/plan/:id/:name",
    name: "group-plan",
    component: GroupPlan,
    meta: { requiresAuth: true }
  },
  {
    path: "/management/group/user/:id/:name",
    name: "group-user",
    component: GroupUser,
    meta: { requiresAuth: true }
  },
  {
    path: "/management/group/create",
    name: "group-create",
    component: Group_Createpage,
    meta: { requiresAuth: true }
  },

  {
    path: '/manangement/user',
    name: 'test_management_user',
    component: test_management_user
  },

  {
    path: '/',
    name: 'Home2',
    component: mapPage
  },
  {
    path: '/dashboard',
    name: 'Dashboard',
    component: dashboardPage
  },
  {
    path: '/dashboardtest',
    name: 'DashboardTest',
    component: dashboardPageTest
  },
  {
    path: '/devices',
    name: 'Devices',
    component: listDevicesPage
  },
  {
    path: '/users',
    name: 'Users',
    component: listUsersPage
  }

]

const router = createRouter({
  history: createWebHistory(),
  routes
})
async function autoRefreshToken() {
  const refreshToken = localStorage.getItem("refreshToken");
  if (!refreshToken) return null;

  try {
    const response = await fetch(`${process.env.VUE_APP_API_URL}/auth/refresh`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ refreshToken: refreshToken }),
    });

    const data = await response.json();

    if (data.accessToken) {
      localStorage.setItem("accessToken", data.accessToken);
      return data.accessToken;
    } else {
      return null;
    }
  } catch (error) {
    console.error("Error refreshing token:", error);
    return null;
  }
}

router.beforeEach(async (to, from, next) => {
  // ถ้าเข้าเว็บผ่าน subdomain ที่ตั้งค่า auto-login ไว้ (src/config/subdomainAccounts.js)
  // และยังไม่มี accessToken จะ login ให้อัตโนมัติก่อนเข้าหน้าใดๆ
  await autoLoginForSubdomain();

  const token = localStorage.getItem("accessToken");

  // role Admin เข้าหน้าจัดการแพลตฟอร์ม (/management/*) ไม่ได้ -> กลับหน้าหลัก
  const role = String(localStorage.getItem("role") || "").toLowerCase();
  if (role === "admin" && to.path.startsWith("/management")) {
    return next("/");
  }

  if (to.meta.requiresAuth) {
    if (!token) {
      return next("/login");
    }

    try {
      // 1. ยิงเพื่อเช็ค token เดิม
      await axios.get(`${process.env.VUE_APP_API_URL}/auth/test`, {
        headers: { Authorization: `Bearer ${token}` },
      });

      return next(); // Token เดิมใช้ได้
    } catch (err) {
      console.warn("Access token invalid. Trying to refresh...");

      // 2. ต่ออายุ token
      const newToken = await autoRefreshToken();

      if (!newToken) {
        // refreshToken ก็ใช้ไม่ได้ → logout
        localStorage.removeItem("accessToken");
        localStorage.removeItem("refreshToken");
        return next("/login");
      }

      // 3. retry /auth/test ด้วย accessToken ใหม่
      try {
        await axios.get(`${process.env.VUE_APP_API_URL}/auth/test`, {
          headers: { Authorization: `Bearer ${newToken}` },
        });

        return next(); // OK หลัง refresh
      } catch (err2) {
        // ยังพัง → ต้อง login ใหม่
        localStorage.removeItem("accessToken");
        localStorage.removeItem("refreshToken");
        return next("/login");
      }
    }
  } else {
    return next();
  }
});

// const router = createRouter({
//   history: createWebHistory(),
//   routes,
// });
// router.beforeEach(async (to, from, next) => {
//   const token = localStorage.getItem('accessToken')

//   if (to.meta.requiresAuth) {
//     if (!token) {
//       return next('/login')
//     }

//     try {
//       // ตรวจสอบ token จริงกับ API
//       await axios.get(`${process.env.VUE_APP_API_URL}/auth/test`, {
//         headers: {
//           Authorization: `Bearer ${token}`
//         }
//       })

//       next() // ไปหน้าต่อไปได้
//     } catch (err) {
//       // token หมดอายุ/ไม่ถูกต้อง หรือเซิร์ฟเวอร์ไม่ตอบ
//       localStorage.removeItem('accessToken')
//       next('/login')
//     }
//   } else {
//     next()
//   }
// })


export default router